import toast from 'react-hot-toast';
import { useAssignmentTransferAllAssignmentsForUserAndDate } from 'api/assignment/assignment';

interface UseTransferAssignmentsParams {
  onSuccess?: () => void;
}

// eslint-disable-next-line import/no-default-export
export default function useTransferAssignments(params?: UseTransferAssignmentsParams) {
  const { mutateAsync, isLoading } = useAssignmentTransferAllAssignmentsForUserAndDate();

  const transferAssignments = async (
    fromUserId: number,
    toUserId: number,
    date: Date
  ) => {
    try {
      const result = await mutateAsync({
        data: {
          fromUserId,
          toUserId,
          date,
        },
      });

      if (result.success) {
        const totalTransferred =
          result.transferredAssignmentIds.length +
          result.transferredAssignmentRequestIds.length;

        toast.success(
          `Flyttade ${totalTransferred} uppdrag/förfrågningar till den nya fälttestaren`
        );

        params?.onSuccess?.();
      } else {
        toast.error(
          result.errorMessage || 'Kunde inte flytta uppdraget'
        );
      }

      return result;
    } catch (error: any) {
      const errorMessage =
        error.response?.data?.message ||
        error.message ||
        'Ett okänt fel uppstod vid flytt av uppdrag';
      toast.error(errorMessage);
      return null;
    }
  };

  return {
    transferAssignments,
    isTransferring: isLoading,
  };
}
